@if (isInitialized) {
  <oe-navigation-view [title]="component.alias" [component]="component">
    <app-update></app-update>
  </oe-navigation-view>
}
